import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import { statesConst } from "_constants";
import breakpoints from "_constants/breakpoints";

const Container = styled.div`
  min-width: 100%;
  max-width: 100%;

  @media (max-width: ${breakpoints.mobileL}) {
    padding: 0;
    margin-top: 0px;
  }
`;
const Title = styled.h1`
  width: 100%;
  font-weight: bold;
  font-size: 16px;
  color: #7b848d;
`;
const OwnerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  min-width: 100%;
  max-width: 100%;
  margin-bottom: 48px;
`;
const Group = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 100%;
  padding: 16px 0;

  &:nth-child(2n + 1) {
    background-color: #fafaff;
  }

  ${({ mode }) =>
    mode === "row" &&
    css`
      flex-direction: row;
    `}

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
  }
`;
const Label = styled.div`
  min-width: 50%;
  max-width: 50%;
  font-weight: normal;
  font-size: 12px;
  padding-right: 20px;
  color: #7b848d;
  text-transform: uppercase;

  @media (max-width: ${breakpoints.tablet}) {
    padding-right: 0;
    max-width: 100%;
  }
`;
const Data = styled(Label)`
  text-transform: none;
  font-weight: bold;
`;

function Owner({ index, partyName, partyType, legalEntityTypeCode, address1, city, state, postcode }) {
  const title = () => {
    switch (index) {
      case 0:
        return <Title>Current Trademark Owners</Title>;
      case 1:
        return <Title>Trademark Owner History</Title>;
      default:
        return null;
    }
  };

  return (
    <OwnerContainer>
      {title()}
      <Group mode="row">
        <Label>Party name</Label>
        <Data>{partyName}</Data>
      </Group>

      <Group mode="row">
        <Label>Party type</Label>
        <Data>{partyType}</Data>
      </Group>

      <Group mode="row">
        <Label>Legal entity type</Label>
        <Data>{legalEntityTypeCode}</Data>
      </Group>

      <Group mode="row">
        <Label>Address</Label>
        <Data>{`${address1}, ${city}, ${statesConst[state]}, ${postcode}`}</Data>
      </Group>
    </OwnerContainer>
  );
}

Owner.propTypes = {
  index: PropTypes.number,
  partyName: PropTypes.string,
  partyType: PropTypes.string,
  legalEntityTypeCode: PropTypes.string,
  address1: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  postcode: PropTypes.string,
};

function OwnerList({ owners }) {
  return (
    <Container>
      {owners && owners.length === 0 ? (
        <Title>No Owners</Title>
      ) : (
        owners.map((ownerInfo, idx) => <Owner key={idx} index={idx} {...ownerInfo} />)
      )}
    </Container>
  );
}

OwnerList.propTypes = {
  owners: PropTypes.arrayOf(PropTypes.object),
};

export default OwnerList;
